import clsx from 'clsx';

interface CommentBodyWrapperProps {
  children: React.ReactNode;
}

export function CommentBodyWrapper({ children }: CommentBodyWrapperProps) {
  return <div className={clsx('text-sm text-gray-900')}>{children}</div>;
}
